import './style.scss';

import { tns } from "tiny-slider"
import GLightbox from "glightbox";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

import TomSelect from 'tom-select/dist/js/tom-select.base.js';

// import { FsLightbox } from "fslightbox";

document.addEventListener( 'DOMContentLoaded', () => {
	// Lazy Image Fade
	document.querySelectorAll( 'img[loading="lazy"]' ).forEach( ( img ) => {
		if( img.complete == true ) {
			img.classList.add( 'has-loaded' );
		}
		img.addEventListener( "load", ( e ) => {
			e.target.classList.add( 'has-loaded' );
		} );
	} );

	// Scroll Image Fade
	let mm = gsap.matchMedia();
	mm.add( "(min-width: 600px)", () => {
		if( document.querySelector( 'body:not(.page-template-page-leasing) header.wp-block-template-part' ) ) {
			const height = document.querySelector( 'header.wp-block-template-part' ).offsetHeight;
			const navHeight = document.querySelector( '#floating-nav' ).offsetHeight;
			const offset = ( height - navHeight ) * -1;
			// console.log( height );
			document.querySelector(':root').style.setProperty( '--header-height', offset + 'px' );
		}
		else {
			document.querySelector(':root').style.setProperty( '--header-height', '0' );
		}
		
		// Pin Header on Default Template
		if( document.querySelector( '#floating-nav' ) ) {
			const prevHeader = document.querySelector( '#floating-nav' ).previousElementSibling;

			gsap.timeline( {
				scrollTrigger: {
					trigger: prevHeader,
					endTrigger: document.querySelector( 'footer' ),
					start: "bottom top",
					scrub: true,
					toggleClass: { targets: '#floating-nav', className: 'is-pinned' },
					// once: true,
					// markers: true
				}
			} );
		}

		// Fade in on scroll
		// document.querySelectorAll( 'body.page-template-page-leasing .entry-content.wp-block-post-content > *:not(.wp-block-cover), body.page-template-page-leasing .entry-content.wp-block-post-content .wp-block-gallery .wp-block-image' ).forEach( ( block ) => {
		// 	gsap.timeline( {
		// 		scrollTrigger: {
		// 			trigger: block,
		// 			start: "top 80%",
		// 			scrub: true,
		// 			toggleClass: 'is-visible',
		// 			once: true,
		// 			markers: true
		// 		}
		// 	} );
		// } );

		if( document.querySelector( '.leasing-header.wp-block-template-part' ) ) {
			gsap.timeline( {
				scrollTrigger: {
					trigger: '#leasing-above',
					endTrigger: document.querySelector( '#contact' ),
					start: "top 5px",
					end: "bottom bottom",
					scrub: true,
					toggleClass: { className: 'show-logo', targets: ['.leasing-header.wp-block-template-part'] },
					// once: true,
					// markers: true
				}
			} );
		}
	} );

	// Hash Links
	document.querySelectorAll( 'nav a[href="#"]' ).forEach( ( item ) => { 
		item.addEventListener( 'click', ( e ) => { 
			e.preventDefault();
		} );
	} );	

	// Cards loaded
	document.querySelectorAll( '.map-cards > li > ul' ).forEach( ( slider, i ) => {
		
		slider.addEventListener( 'cards-loaded', ( e ) => {
			if( e.target.style.display != "none" ) {
				// Slider
				tns( {
					container: e.target,
					mode: 'carousel',
					items: 1,
					autoplay: false,
					autoplayButtonOutput: false,
					nav: false,
					lazyload: true,
					controlsText: ["", ""],
					gutter: 30,
					responsive: {
						640: {
							items: 2
						},
						768: {
							items: 3
						},
						900: {
							items: 4
						}
					}
				} );
				
				// Maps center
				// document
				e.target.querySelectorAll( '.card' ).forEach( ( card ) => { 
					card.addEventListener( 'mouseover', ( e ) => { 
						const cardSelected = ( e.target.classList.contains('card') ) ? e.target : e.target.closest( '.card' );
						const cLat = parseFloat( cardSelected.dataset['lat'] );
						const cLng = parseFloat( cardSelected.dataset['lng'] );
						const newCenter = { lat: cLat, lng: cLng };
						if( map.getCenter() != newCenter ) {
							map.setZoom( 19 );
							map.panTo( newCenter );
							// console.log( newCenter );
						}
					} );
				} );
			}
		} );
	} );

	document.querySelectorAll( '.map-buttons a.wp-block-button__link' ).forEach( ( button, i ) => { 
		button.addEventListener( 'click', ( e ) => {
			const type = e.target.dataset['type'];
			const button = e.target.parentElement;
			// Check if not already selected 
			if( !button.classList.contains( 'is-active' ) ) {
				const prevType = document.querySelector( '.map-buttons .is-active .wp-block-button__link' )?.dataset['type'];
				document.querySelector( '.map-buttons .is-active' )?.classList.remove( 'is-active' );
				document.querySelector( '.map-cards .is-active' )?.classList.remove( 'is-active' );

				button.classList.add( 'is-active' );
				document.querySelector( '.map-cards .' + type )?.classList.add( 'is-active' );

				// Update pins
				if( pins[ prevType ] !== undefined ) {
					pins[ prevType ].forEach( ( pin ) => { 
						pin.setMap( null );
					} );
				}
				if( pins[ type ] !== undefined ) {
					pins[ type ].forEach( ( pin ) => { 
						pin.setMap( map );
					} );
				}
			}
		} );
	} );

	// Notice
	if( document.querySelector( '#notice' ) ) {
		// Has notice
		if( !localStorage.getItem( '140stg--important-message' ) ) {
			// Show message
			document.body.classList.toggle( 'show-message' );
		}

		document.querySelector( '#notice a' )?.addEventListener( 'click', ( e ) => { 
			e.preventDefault();
			document.body.classList.toggle( 'show-message' );
			localStorage.setItem( '140stg--important-message', 1 );
		} );
	}
	
	// Search
	document.querySelectorAll( '.search-load' ).forEach( ( searchButton ) => { 
		searchButton.addEventListener( 'click', ( e ) => { 
			e.preventDefault();
			document.body.classList.toggle( 'search-visible' );
		} );
	} );

	document.querySelector( '.search-form .close-me' )?.addEventListener( 'click', ( e ) => { 
		e.preventDefault();
		document.body.classList.toggle( 'search-visible' );
	} );

	// Date in footer
	if( document.querySelector( '.copyright-date' ) ) {
		const html = document.querySelector( '.copyright-date' ).innerHTML;
		const now = new Date();

		document.querySelector( '.copyright-date' ).innerHTML = html.replace( '{{DATE}}', now.getFullYear() );
	}

	// Leasing Page
	if( document.body.classList.contains( 'page-template-page-leasing' ) ) {
		// Mark items for lightbox
		document.querySelectorAll( 'a[href*=".jpg"], a[href*=".png"]' ).forEach( ( link, i ) => {
			link.classList.add( 'glightbox' );
		} );

		// Init lightbox
		GLightbox( {
			touchNavigation: true,
			loop: true,
			autoplayVideos: true
		} );

		// View Gallery button
		document.querySelector( 'a[href*="#view-gallery"]' )?.addEventListener( 'click', () => {
			if( document.querySelectorAll( 'a[href*=".jpg"], a[href*=".png"]' ).length ) {
				document.querySelectorAll( 'a[href*=".jpg"], a[href*=".png"]' )[0].click();
			}
		} );
	}

	document.querySelectorAll( '.map-buttons a.wp-block-button__link' ).forEach( ( button, i ) => { 
		button.addEventListener( 'click', ( e ) => {
			const type = e.target.dataset['type'];
			const button = e.target.parentElement;
			// Check if not already selected 
			if( !button.classList.contains( 'is-active' ) ) {
				const prevType = document.querySelector( '.map-buttons .is-active .wp-block-button__link' )?.dataset['type'];
				document.querySelector( '.map-buttons .is-active' )?.classList.remove( 'is-active' );
				document.querySelector( '.map-cards .is-active' )?.classList.remove( 'is-active' );

				button.classList.add( 'is-active' );
				document.querySelector( '.map-cards .' + type )?.classList.add( 'is-active' );

				// Update pins
				if( pins[ prevType ] !== undefined ) {
					pins[ prevType ].forEach( ( pin ) => { 
						pin.setMap( null );
					} );
				}
				if( pins[ type ] !== undefined ) {
					pins[ type ].forEach( ( pin ) => { 
						pin.setMap( map );
					} );
				}
			}
		} );
	} );

	// Styled Select
	// document.querySelectorAll('.page-template-page-leasing .frm_forms select' )
	new TomSelect( ".page-template-page-leasing .frm_forms select" , {
		create: true,
		maxItems: 1
	} );
} );

window.addEventListener( "load", () => {
	document.body.classList.add( "window-loaded" );
} );